import { memo } from 'react'
import { VIEWS } from '../../../containers/auth/modals'
import Link from 'next/link'
import { useAuth } from '../../../contexts/auth'
import { ROUTES } from '../../../constants'
import Facebook from '../../svg/facebook'
import Twitter from '../../svg/twitter'
import Instagram from '../../svg/instagram'
import Reddit from '../../svg/reddit'
// import Blog from '../../svg/blog'

const Footer = memo(({ footerType }) => {
  const [{ isAuthenticated, userDetails }, { setAuthModal }] = useAuth()

  return (
    <footer>
      <div className='container'>
        <nav className='topNavigation flex justifyBetween alignCenter'>
          <div className='internalRoutes anchors'>
            <ul className='flex alignCenter'>
              <li>
                <Link legacyBehavior href={`${ROUTES.Buy}`}>
                  <a>Buy a Vehicle</a>
                </Link>
              </li>
              <li>
                <Link legacyBehavior href={ROUTES.Sell}>
                  <a>Sell a Vehicle</a>
                </Link>
              </li>
              <li>
                <Link legacyBehavior href={ROUTES.GetVerified}>
                  <a>Get Verified</a>
                </Link>
              </li>
              <li>
                <Link legacyBehavior href={ROUTES.NeedHelp}>
                  <a>Need Help?</a>
                </Link>
              </li>
            </ul>
          </div>
          <div className='socialNetworks'>
            <a
              aria-label='facebook page'
              href='https://facebook.com/DrivrzXchange-101501255263506'
              target='_blank'
              rel='nofollow noopener noreferrer'
            >
              <Facebook color={footerType} />
            </a>
            <a
              aria-label='twitter page'
              href='https://twitter.com/DrivrzXchange'
              target='_blank'
              rel='nofollow noopener noreferrer'
            >
              <Twitter color={footerType} />
            </a>
            <a
              aria-label='Reddit page'
              href='https://reddit.com/r/DrivrzXchange/'
              target='_blank'
              rel='nofollow noopener noreferrer'
            >
              <Reddit color={footerType} />
            </a>
            <a
              aria-label='instagram page'
              href='https://instagram.com/drivrzxchange/'
              target='_blank'
              rel='nofollow noopener noreferrer'
            >
              <Instagram color={footerType} />
            </a>
            {/* <Link legacyBehavior href={ROUTES.Blog}>
              <a>
                <Blog color={footerType} />
              </a>
            </Link> */}
          </div>
        </nav>
        <nav className='bottomNavigation flex justifyBetween alignCenter'>
          <ul className='navigation flex'>
            <li>
              <Link legacyBehavior href={ROUTES.About}>
                <a>About</a>
              </Link>
            </li>
            <li>
              <Link legacyBehavior href={ROUTES.Contact}>
                <a>Contact</a>
              </Link>
            </li>
            <li>
              <a
                className='link'
                onClick={() => {
                  setAuthModal({ open: true, view: VIEWS.Login })
                }}
              >
                <span>Sign In</span>
              </a>
            </li>
          </ul>
          <div className='copyRight'>
            <span>Copyright 2021 D2D Auto Auction LLC | All Rights Reserved</span>
          </div>
        </nav>
      </div>

      <style jsx>{`
        footer {
          background: #fff;
          font-size: 1.6rem;
        }
        a.link {
          cursor: pointer;
        }

        .container {
          max-width: 192rem;
          width: 100%;
          margin: 0 auto;
          padding: 0 4rem;
        }

        .topNavigation {
          padding: 4.7rem 0 2.2rem;
          border-bottom: 1px solid var(--separator-line-color);

          a {
            display: inline-block;
            margin: 0 4.5rem 0 0;
            font-weight: 700;
            font-size: 1.125em;
          }
        }
        .bottomNavigation {
          padding: 2.7rem 0 5.2rem;

          a {
            margin: 0 3.5rem 0 0;
          }
        }

        .socialNetworks {
          a {
            margin: 0 0 0 1.6rem;
          }

          :global(svg) {
            fill: var(--primary-color);
          }
        }
        @media (max-width: 1024px) {
          footer {
            font-size: 1rem;

            .anchors,
            .navigation {
              display: none;
            }

            .container {
              padding: 0 1.2rem;
            }

            .topNavigation,
            .bottomNavigation {
              justify-content: center;
            }

            .topNavigation {
              padding: 3.2rem 0 1.7rem;

              a {
                margin: 0 0.65rem;

                :global(svg) {
                  width: 2rem;
                  height: 2rem;
                }
              }
            }

            .bottomNavigation {
              padding: 1.7rem 0 2.2rem;
            }
          }
        }
      `}</style>
    </footer>
  )
})

export default Footer
